import React, { useContext } from 'react'
import Context from '../../context/Context'
import { Link } from 'react-router-dom'
import { PaymentTypes } from '../../helpers/Constants'

const OneClick = () => {
  const context = useContext(Context)

  if (
    context.organizationSettings.isOneClickActive === '1' &&
    context.invoice.current_payment_type_id !== PaymentTypes.DIRECT_DEBIT &&
    context.invoice.current_payment_type_id !== PaymentTypes.ELECTRONIC_INVOICE
  ) {
    return (
      <div className="row mt-2">
        <div className="col-12 text-center">
          <Link
            style={context.style.button}
            to={'oneclick' + context.url}
            className="btn btn-primary custom-btn-payment">
            Betala nu
          </Link>
        </div>
      </div>
    )
  }

  return ''
}

export default OneClick
